import React, {useEffect} from "react";
import {AlertContainer, AlertType} from "../../components/ui/Alert";
import {clearGlobalAlert, hideGlobalAlert} from "./slice";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {Done} from "../../icon/Icon";

export const Alert = (): React.ReactElement | null => {

    const dispatch = useAppDispatch()
    const {show, message, type} = useAppSelector((state) => state.alert)

    useEffect(() => {
        const hideAlertTimeout = setTimeout(() => {
            if (show) {
                dispatch(hideGlobalAlert())
            }
        }, 4000)

        const resetAlertTimeout = setTimeout(() => {
            if (!show) {
                dispatch(clearGlobalAlert())
            }
        }, 2000)

        return () => {
            clearTimeout(hideAlertTimeout)
            clearTimeout(resetAlertTimeout)
        }
    }, [show])

    if (!message) {
        return null
    }

    return <AlertContainer
                type={type}
                className={show ? 'alertVisible' : 'alertInvisible'}>
                {type === AlertType.Success && <Done/>}
                {message}
            </AlertContainer>
}
